import {
  faBacteria,
  faHeadSideVirus,
  faLungsVirus,
  faTableList,
  faUniversalAccess,
  faViruses,
  faXmark
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Component } from 'react';
import {
  Badge,
  Button,
  Card,
  Col,
  Modal,
  Row,
  Table
} from 'react-bootstrap';
import { Bar } from 'react-chartjs-2';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { GET } from '../../api';
import { brand_colors } from '../../helpers/brand_colors_helper';
import { t } from '../../helpers/translation_helper';

const barChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
      position: 'bottom',
    },
  },
  scales: {
    y: {
      ticks: {
        precision: 0
      },
    },
  },
};

class NurseDashboard extends Component {
  state = {
    totalChronicIllnessCases: 0,
    totalIllnessCases: 0,
    totalAllergyCases: 0,
    totalConditionCases: 0,
    totalSENCases: 0,
    data: [],
    incidentReport: [],
    detailModal: {
      show: false,
      title: '',
      type: '',
      children: {
        show: false,
        title: '',
        open: (title) => {
          this.setState({
            detailModal: {
              ...this.state.detailModal,
              children: {
                ...this.state.detailModal.children,
                title,
                show: true,
              },
            },
          });
        },
        close: () => {
          this.setState({
            detailModal: {
              ...this.state.detailModal,
              children: {
                ...this.state.detailModal.children,
                show: false,
                title: '',
              },
            },
          });
        },
      },
      open: (title, type) => {
        this.setState({
          detailModal: { ...this.state.detailModal, show: true, title, type },
        });
      },
      close: () => {
        this.setState({
          detailModal: {
            ...this.state.detailModal,
            show: false,
            title: '',
            type: '',
            children: {
              ...this.state.detailModal.children,
              show: false,
              title: '',
            },
          },
        });
      },
    },
  };

  componentDidMount() {
    this.getChildrenHealth();
    this.getYearlyIncidentReport();
  }

  getChildrenHealth = async () => {
    try {
      const res = await GET('nurse-dashboard/get-children-health');

      const { data } = res;

      const totalChronicIllnessCases = data.filter(
        (item) => item.child_health_type === 'Chronic Illness'
      ).length;

      const totalIllnessCases = data.filter(
        (item) => item.child_health_type === 'Illness'
      ).length;

      const totalConditionCases = data.filter(
        (item) => item.child_health_type === 'Condition'
      ).length;

      const totalAllergyCases = data.filter(
        (item) => item.child_health_type === 'Allergy'
      ).length;

      const totalSENCases = data.filter(
        (item) => item.child_health_type === 'SEN'
      ).length;

      this.setState({
        totalChronicIllnessCases,
        totalIllnessCases,
        totalConditionCases,
        totalAllergyCases,
        totalSENCases,
        data,
      });
    } catch (error) {
      toast.error(t('Failed to fetch details'));
      console.log(error);
    }
  };

  getYearlyIncidentReport = async () => {
    try {
      const res = await GET('nurse-dashboard/get-yearly-incident-report');

      const { data } = res;

      this.setState({ incidentReport: data });

    } catch (error) {
      toast.error(t('Failed to fetch details'));
      console.log(error);
    }
  }

  renderList = (type) => {
    const { data } = this.state;

    let bg;

    switch (type) {
      case 'Chronic Illness':
        bg = '#ED7DAC';
        break;
      case 'Illness':
        bg = '#94E486';
        break;
      case 'Allergy':
        bg = '#F1B24C';
        break;
      case 'Condition':
        bg = '#7ED0EF';
        break;
      case 'SEN':
        bg = '#A965EE';
        break;
      default:
        bg = brand_colors[this.props.defaultTheme.theme_id].color1;
    }

    const grouped = data
      .filter((item) => item.child_health_type === type)
      .reduce((acc, item) => {
        const index = acc.findIndex((x) => x.name === item.child_health_name);
        if (index === -1) {
          acc.push({ name: item.child_health_name, count: 1 });
        } else {
          acc[index].count++;
        }
        return acc;
      }, []);

    const rows = grouped.map((item, index) => {
      return (
        <tr key={index}>
          <td style={{ verticalAlign: 'middle' }}>{item.name}</td>
          <td style={{ textAlign: 'right' }}>
            <button
              className='btn btn-sm'
              style={{ backgroundColor: bg, color: '#fff' }}
              onClick={() => this.state.detailModal.children.open(item.name)}>
              {item.count}
            </button>
          </td>
        </tr>
      );
    });

    return (
      <Row>
        <Col>
          <div style={{ height: 300 }}>
            <Bar
              options={barChartOptions}
              data={{
                labels: grouped.map((item) => item.name),
                datasets: [
                  {
                    label: 'Total',
                    data: grouped.map((item) => item.count),
                    backgroundColor: grouped.map((item) => bg),
                  },
                ],
              }}
              height={305}
            />
          </div>
          {this.state.detailModal.children.show && this.renderChildren()}
        </Col>
        <Col>
          <Table size='sm'>
            <tbody>{rows}</tbody>
          </Table>
        </Col>
      </Row>
    );
  };

  renderChildren = () => {
    const { data, detailModal } = this.state;

    const children = data.filter(
      (item) =>
        item.child_health_name === detailModal.children.title &&
        item.child_health_type === detailModal.type
    );

    return (
      <Table size='sm'>
        <tbody>
          <tr>
            <td colSpan={2} style={{ fontWeight: 'bold' }}>
              <Row>
                <Col>{detailModal.children.title}</Col>
                <Col md='auto'>
                  <Button
                    variant='dark'
                    size='sm'
                    onClick={() => detailModal.children.close()}>
                    <FontAwesomeIcon icon={faXmark} />
                  </Button>
                </Col>
              </Row>
            </td>
          </tr>
          {children.map((item, index) => {
            return (
              <tr key={index}>
                <td width='35%'>{item.child_name}</td>
                <td>
                  {item.classes.map((item, index) => {
                    return (
                      <Badge
                        key={index}
                        bg='light'
                        style={{ color: '#000' }}
                        className='me-1'>
                        {item}
                      </Badge>
                    );
                  })}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  };

  render() {

    return (
      <div className='grey-section'>
        <Row>
          <Col className='mb-4'>
            <Card
              className='border-0 position-relative'
              style={{ borderRadius: '27px' }}>
              <Card.Body>
                <div
                  style={{
                    margin: '0 auto 10px',
                    width: 100,
                    height: 100,
                    borderRadius: 50,
                    backgroundColor:
                      brand_colors[this.props.defaultTheme.theme_id].color3,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    opacity: 0.7,
                  }}>
                  <FontAwesomeIcon
                    icon={faLungsVirus}
                    style={{
                      fontSize: 40,
                      color:
                        brand_colors[this.props.defaultTheme.theme_id].color8,
                    }}
                  />
                </div>
                <div className='text-center mb-3'>
                  <strong style={{ fontSize: 48 }}>
                    {this.state.totalChronicIllnessCases}
                  </strong>
                </div>
                <div className='mb-1 text-center'>
                  <strong className='text-muted'>
                    {t('Chronic Illnesses')}
                  </strong>
                </div>
              </Card.Body>
              <Button
                onClick={() =>
                  this.state.detailModal.open(
                    'Chronic Illness Cases',
                    'Chronic Illness'
                  )
                }
                variant='light'
                size='sm'
                title={t('View Detail List')}
                style={{
                  position: 'absolute',
                  top: 10,
                  right: 10,
                  borderRadius: 35,
                }}>
                <FontAwesomeIcon icon={faTableList} />
              </Button>
            </Card>
          </Col>
          <Col className='mb-4'>
            <Card
              className='border-0 position-relative'
              style={{ borderRadius: '27px' }}>
              <Card.Body>
                <div
                  style={{
                    margin: '0 auto 10px',
                    width: 100,
                    height: 100,
                    borderRadius: 50,
                    backgroundColor:
                      brand_colors[this.props.defaultTheme.theme_id].color13,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    opacity: 0.7,
                  }}>
                  <FontAwesomeIcon
                    icon={faViruses}
                    style={{
                      fontSize: 40,
                      color:
                        brand_colors[this.props.defaultTheme.theme_id].color8,
                    }}
                  />
                </div>
                <div className='text-center mb-3'>
                  <strong style={{ fontSize: 48 }}>
                    {this.state.totalIllnessCases}
                  </strong>
                </div>
                <div className='mb-1 text-center'>
                  <strong className='text-muted'>{t('Illnesses')}</strong>
                </div>
              </Card.Body>
              <Button
                onClick={() =>
                  this.state.detailModal.open('Illness Cases', 'Illness')
                }
                variant='light'
                size='sm'
                title={t('View Detail List')}
                style={{
                  position: 'absolute',
                  top: 10,
                  right: 10,
                  borderRadius: 35,
                }}>
                <FontAwesomeIcon icon={faTableList} />
              </Button>
            </Card>
          </Col>
          <Col className='mb-4'>
            <Card
              className='border-0 position-relative'
              style={{ borderRadius: '27px' }}>
              <Card.Body>
                <div
                  style={{
                    margin: '0 auto 10px',
                    width: 100,
                    height: 100,
                    borderRadius: 50,
                    backgroundColor:
                      brand_colors[this.props.defaultTheme.theme_id].color16,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    opacity: 0.7,
                  }}>
                  <FontAwesomeIcon
                    icon={faBacteria}
                    style={{
                      fontSize: 40,
                      color:
                        brand_colors[this.props.defaultTheme.theme_id].color8,
                    }}
                  />
                </div>
                <div className='text-center mb-3'>
                  <strong style={{ fontSize: 48 }}>
                    {this.state.totalAllergyCases}
                  </strong>
                </div>
                <div className='mb-1 text-center'>
                  <strong className='text-muted'>{t('Allergies')}</strong>
                </div>
              </Card.Body>
              <Button
                onClick={() =>
                  this.state.detailModal.open('Allergy Cases', 'Allergy')
                }
                variant='light'
                size='sm'
                title={t('View Detail List')}
                style={{
                  position: 'absolute',
                  top: 10,
                  right: 10,
                  borderRadius: 35,
                }}>
                <FontAwesomeIcon icon={faTableList} />
              </Button>
            </Card>
          </Col>
          <Col className='mb-4'>
            <Card
              className='border-0 position-relative'
              style={{ borderRadius: '27px' }}>
              <Card.Body>
                <div
                  style={{
                    margin: '0 auto 10px',
                    width: 100,
                    height: 100,
                    borderRadius: 50,
                    backgroundColor:
                      brand_colors[this.props.defaultTheme.theme_id].color1,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    opacity: 0.7,
                  }}>
                  <FontAwesomeIcon
                    icon={faHeadSideVirus}
                    style={{
                      fontSize: 40,
                      color:
                        brand_colors[this.props.defaultTheme.theme_id].color8,
                    }}
                  />
                </div>
                <div className='text-center mb-3'>
                  <strong style={{ fontSize: 48 }}>
                    {this.state.totalConditionCases}
                  </strong>
                </div>
                <div className='mb-1 text-center'>
                  <strong className='text-muted'>{t('Conditions')}</strong>
                </div>
              </Card.Body>
              <Button
                onClick={() =>
                  this.state.detailModal.open('Condition Cases', 'Condition')
                }
                variant='light'
                size='sm'
                title={t('View Detail List')}
                style={{
                  position: 'absolute',
                  top: 10,
                  right: 10,
                  borderRadius: 35,
                }}>
                <FontAwesomeIcon icon={faTableList} />
              </Button>
            </Card>
          </Col>
          <Col className='mb-4'>
            <Card
              className='border-0 position-relative'
              style={{ borderRadius: '27px' }}>
              <Card.Body>
                <div
                  style={{
                    margin: '0 auto 10px',
                    width: 100,
                    height: 100,
                    borderRadius: 50,
                    backgroundColor: 'rgb(138 21 231)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    opacity: 0.7,
                  }}>
                  <FontAwesomeIcon
                    icon={faUniversalAccess}
                    style={{
                      fontSize: 40,
                      color:
                        brand_colors[this.props.defaultTheme.theme_id].color8,
                    }}
                  />
                </div>
                <div className='text-center mb-3'>
                  <strong style={{ fontSize: 48 }}>
                    {this.state.totalSENCases}
                  </strong>
                </div>
                <div className='mb-1 text-center'>
                  <strong className='text-muted'>{t('SEN')}</strong>
                </div>
              </Card.Body>
              <Button
                onClick={() => this.state.detailModal.open('SEN Cases', 'SEN')}
                variant='light'
                size='sm'
                title={t('View Detail List')}
                style={{
                  position: 'absolute',
                  top: 10,
                  right: 10,
                  borderRadius: 35,
                }}>
                <FontAwesomeIcon icon={faTableList} />
              </Button>
            </Card>
          </Col>
          <Col md={12}>
            <Card className='border-0' style={{ borderRadius: 27 }}>
              <Card.Body>
                <Row>
                  <Col className='ps-5'>
                    <div className='text-center mb-2'>
                      <strong>{t('Yearly Incident Report')}</strong>
                    </div>
                  </Col>
                  <Col md={12}>
                    <div style={{ height: 300 }}>
                      <Bar
                        options={barChartOptions}
                        data={{
                          labels: this.state.incidentReport.map((item) => item.month),
                          datasets: [
                            {
                              label: 'Total',
                              data: this.state.incidentReport.map((item) => item.incidents_count),
                              backgroundColor: '#7ED0EF',
                            },
                          ],
                        }}
                        height={305}
                      />
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Modal
          size='xxl'
          show={this.state.detailModal.show}
          onHide={() => this.state.detailModal.close()}>
          <Modal.Header closeButton>
            <Modal.Title>{this.state.detailModal.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* {this.state.detailModal.children.show
              ? this.renderChildren()
              : this.renderList(this.state.detailModal.type)} */}
            {this.renderList(this.state.detailModal.type)}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  defaultLanguage: state.language.defaultLanguage,
  defaultTheme: state.theme.defaultTheme,
});

export default connect(mapStateToProps, null)(NurseDashboard);
